import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface ProfilePhotoContextType {
  profilePhoto: string | null;
  setProfilePhoto: (photo: string | null) => void;
  removeProfilePhoto: () => void;
}

const ProfilePhotoContext = createContext<ProfilePhotoContextType | undefined>(undefined);

interface ProfilePhotoProviderProps {
  children: ReactNode;
}

const PROFILE_PHOTO_KEY = 'loopra_profile_photo';

export const ProfilePhotoProvider: React.FC<ProfilePhotoProviderProps> = ({ children }) => {
  const [profilePhoto, setProfilePhotoState] = useState<string | null>(null);

  // Carregar foto do localStorage na inicialização
  useEffect(() => {
    try {
      const savedPhoto = localStorage.getItem(PROFILE_PHOTO_KEY);
      if (savedPhoto) {
        setProfilePhotoState(savedPhoto);
      }
    } catch (error) {
      console.warn('Erro ao carregar foto do perfil do localStorage:', error);
    }
  }, []);

  const setProfilePhoto = (photo: string | null) => {
    setProfilePhotoState(photo);
    
    try {
      if (photo) {
        localStorage.setItem(PROFILE_PHOTO_KEY, photo);
      } else {
        localStorage.removeItem(PROFILE_PHOTO_KEY);
      }
    } catch (error) {
      console.warn('Erro ao salvar foto do perfil no localStorage:', error);
    }
  };

  const removeProfilePhoto = () => {
    setProfilePhotoState(null);
    
    try {
      localStorage.removeItem(PROFILE_PHOTO_KEY);
    } catch (error) {
      console.warn('Erro ao remover foto do perfil do localStorage:', error);
    }
  };

  return (
    <ProfilePhotoContext.Provider value={{
      profilePhoto,
      setProfilePhoto,
      removeProfilePhoto
    }}>
      {children}
    </ProfilePhotoContext.Provider>
  );
};

export const useProfilePhoto = (): ProfilePhotoContextType => {
  const context = useContext(ProfilePhotoContext);
  if (context === undefined) {
    throw new Error('useProfilePhoto must be used within a ProfilePhotoProvider');
  }
  return context;
};
